// Build a generic WS action handler compatible with both ChatWindow and UI Designer
export function buildWsStreamHandler(h) {
    return (action) => {
        if (!action || !action.type)
            return;
        switch (action.type) {
            case 'server_error':
            case 'error': {
                h.onServerError?.(action.data || action);
                return;
            }
            case 'character_response_stream': {
                const { text = '', is_streaming } = (action.data || {});
                if (typeof text === 'string')
                    h.onStreamText?.(text, Boolean(is_streaming));
                return;
            }
            case 'character_response':
            case 'assistant_message': {
                const data = action.data || {};
                const text = (data.text ?? data.message ?? '');
                if (typeof text === 'string')
                    h.onFinalText?.(text);
                return;
            }
            case 'session_ready':
            case 'session_started': {
                h.onSessionReady?.();
                return;
            }
            default:
                return;
        }
    };
}
